import React from "react";

import { getNumberDayMonthYear } from "~/libs/getDateOptions";

import SrrRowBase from "./SrrRowBase";

const ReportNSByClient = ({ row, items }) => {
  let maxNum = 0;
  let indexTable = 0;
  for (var i = 0; i < items.length; i++) {
    if (items[i]["soldCars"].length > maxNum) {
      maxNum = items[i]["soldCars"].length;
      indexTable = i;
    }
  }

  const renderItem = [
    row.dealer.DealerName,
    row.dealer.city,
    row.dealer.INN,
    row.dealer.entfCode,
    row.dealer.subject,
    row.dealer.FO,
    row.dealer.status === "active" ? "1" : "0",

    ...row.soldCars
      .map((el) => {
        return [
          el.Car.vin,
          el.Car.collection,
          el.price,
          el.sellerName,
          el.sellerPosition,
          getNumberDayMonthYear({ date: el.dateSales }),
        ];
      })
      .flat(),
  ];

  const leter =
    (items[indexTable]["soldCars"].length - row["soldCars"].length) * 6;

  const arrNew = [];
  for (let i = 0; i < leter; i++) {
    arrNew.push(i);
  }

  return (
    <SrrRowBase cells={[...renderItem, ...arrNew.map(() => "-")]} />
  );
};

export default ReportNSByClient;
